/** Reported when the user record carries no country, so the attribute is never blank. */
export const UNKNOWN_COUNTRY_CODE = 'N/A';

/** Cookiebot signals that the user's cookie-consent decision has changed. */
export const CONSENT_READY_EVENT = 'CookiebotOnConsentReady';

/** Persisted cookie written by the analytics provider after consent is resolved. */
export const CONSENT_COOKIE_NAME = 'cw_consent';

/** Query parameter used by the consent provider for mobile/OAuth handoff. */
export const CONSENT_QUERY_PARAMETER = 'has_cookies_consent';

/** Only this consent value permits attaching a stable Logs user identity. */
export const GRANTED_CONSENT_VALUE = 'granted';
